<app-skeleton-loader
	*ngIf="loading && !visible"
	class="balance-skeleton"
	height="1.75rem"
	borderRadius="1rem"
></app-skeleton-loader>

<!-- No Upgrade button on the indicator: the whole chip is the way into the
     statement. -->
<button
	*ngIf="visible && !showUpgrade"
	type="button"
	class="balance-trigger"
	[matTooltip]="tooltip"
	matTooltipPosition="below"
	data-testid="credit-balance"
	(click)="openStatement()"
>
	<app-balance
		[balance]="credits"
		[indicatorType]="indicatorType"
	></app-balance>
</button>

<!-- app-balance draws its own Upgrade button here, so it is the control and
     this component adds none of its own. -->
<app-balance
	*ngIf="visible && showUpgrade"
	[balance]="credits"
	[indicatorType]="indicatorType"
	[matTooltip]="tooltip"
	matTooltipPosition="below"
	data-testid="credit-balance"
	(buttonClicked)="upgrade()"
></app-balance>
